/* eslint-disable */
/* tslint:disable */
//////////////////////////////////////////////////////////////////////////////
/// Autogenerated by tailwindcss-classnames CLI. https://git.io/JtsPU
/// DO NOT EDIT THIS FILE DIRECTLY!
//////////////////////////////////////////////////////////////////////////////
import classnamesLib from 'clsx';
export var classnames = classnamesLib;
export var tw = classnames;
export default tw;
//# sourceMappingURL=index.js.map